import { shopApi } from 'api';

export const generateItemTitleAnsSubtitle = (
  itemName: string,
  t: Record<string, any>,
) => {
  const formattedName = itemName.replace(/\d{4,}/g, match => {
    return match.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  });

  const match = formattedName.match(/\d{1,3}(,\d{3})*\s*\+\s*\d{1,3}(,\d{3})*/);

  const generateTitle = () => {
    if (match) {
      const numbers = match[0]
        ?.split('+')
        ?.map(str => parseInt(str.replace(/,/g, '').trim()));
      const sum = numbers.reduce((a, b) => a + b);

      const modifiedString = formattedName.replace(
        match[0],
        sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ',
      );

      return modifiedString;
    } else {
      return itemName;
    }
  };

  const generateSubtitle = () => {
    if (!match) {
      return null;
    }

    return `‰ ${match[0]} ${t.authModal.asGift}`;
  };

  return {
    title: generateTitle(),
    subtitle: generateSubtitle(),
  };
};

export const generateSubtitleColor = (itemName: string) => {
  return itemName?.match(/\bgold\b/gi) ? 'var(--yellow)' : 'var(--light-green-grey)';
};

export const countRemainingTime = (item: shopApi.Item, t: Record<string, any>) => {
  if (!item?.periods || item?.periods?.length === 0) {
    return null;
  }

  if (!item?.periods[0]?.date_until) {
    return null;
  }

  // Парсинг даты "until_date" в объект Date
  const untilDate = new Date(item?.periods[0]?.date_until);

  // Получение текущей даты
  const currentDate = new Date();

  // Вычисление разницы в миллисекундах
  const timeDiff = untilDate.getTime() - currentDate.getTime();

  // Вычисление разницы в днях и часах
  const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hoursDiff = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

  // Формирование строки в формате "Xд:Yч" или "Xд" или "Yч"
  let formattedDuration = '';

  if (daysDiff > 0) {
    formattedDuration += `${daysDiff}${t.market.item.shortDay}`;
  }

  if (hoursDiff > 0) {
    if (formattedDuration !== '') {
      formattedDuration += ':';
    }
    formattedDuration += `${hoursDiff}${t.market.item.shortHour}`;
  }

  return formattedDuration;
};
